export enum Event {
  Hidden = "HIDDEN",
}

export interface EventMap {
  [Event.Hidden]: undefined
}
